








































































import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';

import {
  CloseFullscreenWrapper,
  FormValidation,
  LoadingMessage,
} from '@/mixins';

import {
  FullscreenWrapper,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';

import { api, MEMBER_API_SUB_URLS } from '@/api';
import { ExtendMixins } from '@/services';
import { AccountNumberOverlayFormModel } from '@/@types/member';

interface Data {
  confirmBeforeClose: boolean;
  isSubmitLoading: boolean;
  showSubmitSuccessMessage: boolean;
  successMessage: string;
  showSubmitErrorMessage: boolean;
  errorMessage: string;
  formModel: AccountNumberOverlayFormModel;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  LoadingMessage,
).extend({
  name: 'ViewAccountNumber',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      confirmBeforeClose: false,
      isSubmitLoading: false,
      showSubmitSuccessMessage: false,
      successMessage: this.params.successMessage,
      showSubmitErrorMessage: false,
      errorMessage: this.params.errorMessage,
      formModel: {
        token: '',
      },
    };
  },
  beforeMount() {
    this.constructShowErrorModel('formModel');
  },
  validations: {
    formModel: {
      token: {
        required,
      },
    },
  },
  computed: {
    // VALIDATIONS
    tokenErrors(): string[] {
      const formField = 'formModel.token';
      return this.FormValidationMixin.constructErrors(formField, [
        this. FormValidationMixin.validateField(
          formField,
          [
            'global_form-error_token_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      if (this.errorMessage === this.params.errorMessageTokenInvalid) {
        // We need user to start over and request a new token
        this.closeFullscreenWrapper();
        return;
      }
      this.showSubmitErrorMessage = false;
      this.confirmBeforeClose = true;
    },
    validateToken(): void {
      this.isSubmitLoading = true;
      api
        .get(
          `${MEMBER_API_SUB_URLS.members}/${
            this.$store.getters.user.memberId
          }/validate-token`,
          {
            headers: {
              'x-token': this.formModel.token,
            },
          },
        )
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSubmitSuccessMessage = true;
          this.isSubmitLoading = false;
        })
        .catch((error) => {
          if (error.status === 403) {
            this.errorMessage = this.params.errorMessageTokenInvalid;
          }

          this.confirmBeforeClose = false;
          this.showSubmitErrorMessage = true;
          this.isSubmitLoading = false;
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
